module.exports = __webpack_public_path__ + "./img/25.531888776d0bcb5b8d91e066bbec744c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Shared/images/25.gif
// module id = ./src/components/Shared/images/25.gif
// module chunks = 0